import { Asset } from './Asset';
import { format } from 'date-fns';
import { PropertyDefinition } from './PropertyDefinition';

const today = new Date();

export type FormInitialData = {
  startMonth: { value: number; label: string };
  startYear: { value: number; label: string };
  name: string;
  endMonth: { value: number; label: string };
  endYear: { value: number; label: string };
  firmName: PropertyDefinition | undefined;
  productName: PropertyDefinition | undefined;
  assets: Asset[];
};

export const NullFormInitialData = {
  startMonth: { value: today.getMonth(), label: format(today, 'MMMM') },
  startYear: {
    value: today.getFullYear(),
    label: today.getFullYear().toString(),
  },
  name: '',
  endMonth: { value: today.getMonth(), label: format(today, 'MMMM') },
  endYear: {
    value: today.getFullYear(),
    label: today.getFullYear().toString(),
  },
  firmName: undefined,
  productName: undefined,
  assets: [],
};
